<template>
  <div ref="parentbanner" class="banner-cta-slim__container">
    <nuxt-link
      v-if="banner.ctaLink"
      :to="
        banner.ctaLink !== ''
          ? banner.ctaLink
          : localePath({ name: 'contacts' })
      "
      class="banner-cta-slim is-rounded-wrap button-circle-1-trigger"
      :class="{
        'is-hover': isHover,
        'is-visible': isVisible,
      }"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
    >
      <div class="banner-cta-slim__wrap">
        <div
          v-if="hasPreview"
          class="banner-cta-slim-inside__video"
          data-animate="banner-cta-slim-video"
        >
          <WidgetVideo
            class="is-cover"
            :videoUrl="banner.videoUrl"
            :loop="true"
            :forcePlay="isHover"
            :playInViewport="touch"
            :autoplay="false"
            :muted="true"
            :preload="'auto'"
            @play="onViewportEnter"
            @pause="onViewportLeave"
          />
        </div>
        <div class="banner-cta-slim__text-wrap">
          <div
            v-if="banner.title"
            v-html="banner.title"
            class="banner-cta-slim__text"
          />

          <div v-html="banner.subtitle" class="banner-cta-slim__subtitle" />
        </div>

        <div class="banner-cta-slim__button">
          <div
            class="banner-cta-slim__button__label button-round-1 is-gradient is-big"
          >
            <span>
              {{ banner.ctaLabel }}
            </span>
          </div>
        </div>
      </div>
    </nuxt-link>
  </div>
</template>

<script>
export default {
  name: 'BannerCtaSlim',
}
</script>

<script setup>
import { gsap } from 'gsap'

const parentbanner = ref(null)
const isHover = ref(false)
const isVisible = ref(false)
const touch = ref(false)

const duration = 0.6
const ease = 'power2.inOut'

const props = defineProps({
  banner: Object,
})

let observer = null

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints
  playerObserver()
})

onUnmounted(() => {
  // Disconnect the observer when the component unmounts
  if (observer) {
    observer.disconnect()
  }
})

const hasPreview = computed(() => props.banner?.videoUrl)

const onMouseEnter = () => {
  if (touch.value) return false

  const parent = parentbanner.value
  const video = parent?.querySelector('[data-animate="banner-cta-slim-video"]')

  isHover.value = true

  if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 1, duration, ease })
  }
}

const onMouseLeave = () => {
  if (touch.value) return false
  const parent = parentbanner.value
  const video = parent?.querySelector('[data-animate="banner-cta-slim-video"]')

  isHover.value = false

  if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 0, duration, ease })
  }
}

const onViewportEnter = () => {
  const parent = parentbanner.value
  const video = parent?.querySelector('[data-animate="banner-cta-slim-video"]')

  isHover.value = true

  if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 1, duration, ease })
  }
}

const onViewportLeave = () => {
  const parent = parentbanner.value
  const video = parent?.querySelector('[data-animate="banner-cta-slim-video"]')

  isHover.value = false

  if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 0, duration, ease })
  }
}

const playerObserver = () => {
  observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (touch.value) {
          // If the video is visible in the viewport and autoplay is not prevented
          if (entry.isIntersecting) {
            isVisible.value = true
          } else {
            isVisible.value = false
          }
        } else {
          isVisible.value = false
        }
      })
    },
    {
      threshold: 0.5, // trigger when at least 50% of the video is visible
    }
  )

  observer.observe(parentbanner.value)
}
</script>

<style lang="scss">
@import './style.scss';
</style>
